import React from 'react';
import { benefitsPageData } from './markup'
import Index from '../index'

export default ({ location }) => {
  return (<Index pageData={benefitsPageData} location={location} />)
}